import { Button, Icon } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { FC, useEffect, useRef, useState } from 'react';
import { useFocusOut } from '../../../../../hooks';
import { NavigationDropdown } from '../../NavigationDropdown';
import { HWSSecondaryNavigationModel } from '../HWSPrimaryDetachedNavigation.types';
import {
  StyledHWSPrimaryDetachedNavigation,
  StyledMainMenu,
  StyledMainMenuItem,
} from './HWSSecondaryNavigationDesktop.styles';

const HWSSecondaryNavigationDesktop: FC<HWSSecondaryNavigationModel> = props => {
  const [selectedMainMenuItemIndex, setSelectedMainMenuItemIndex] = useState<number>(-1);
  const mainMenuRef = useRef<HTMLDivElement | null>(null);

  const toggleBodyScroll = (disable: boolean) => {
    document.body.style.overflow = disable ? 'hidden' : 'inherit';
  };

  const handleFocusOut = (isFocusOut: boolean) => {
    if (isFocusOut) {
      setSelectedMainMenuItemIndex(-1);
      toggleBodyScroll(false);
    }
  };

  useFocusOut({ ref: mainMenuRef.current, onFocusOut: handleFocusOut });

  useEffect(() => {
    return () => {
      toggleBodyScroll(false);
    };
  }, []);
  return (
    <StyledHWSPrimaryDetachedNavigation className="m-container-fullbleed" ref={mainMenuRef}>
      <nav aria-label={props?.navigationAriaLabel} data-testid="navigation-menu-desktop">
        <div className="container">
          <StyledMainMenu>
            {props?.hwsSectionNavigationItems?.map((mainMenuItem, menuItemIndex: number) => (
              <StyledMainMenuItem
                id={`main-menu-item-${menuItemIndex}`}
                key={`main-menu-item-${menuItemIndex}`}
                onClick={() => {
                  const isSameItem = selectedMainMenuItemIndex === menuItemIndex;
                  setSelectedMainMenuItemIndex(isSameItem ? -1 : menuItemIndex);
                  toggleBodyScroll(!isSameItem);
                }}
                className={clsx(
                  selectedMainMenuItemIndex === menuItemIndex && 'selected',
                  mainMenuItem.menuItemLabel === props?.activeMenuItem?.menuLabel && 'active'
                )}
                data-testid={`main-menu-item-${menuItemIndex}`}
              >
                <Button
                  isLink={!mainMenuItem?.sectionNavigationSubItems?.length}
                  href={
                    // eslint-disable-next-line no-script-url
                    mainMenuItem?.sectionNavigationSubItems?.length ? 'javascript:void(0)' : mainMenuItem.menuItemPath
                  }
                  className="main-menu-item color-scheme7"
                  aria-expanded={selectedMainMenuItemIndex === menuItemIndex}
                  aria-controls={`main-menu-item-${menuItemIndex}`}
                  trackingProperties={props?.trackingProperties}
                  target={mainMenuItem?.openInNewTab ? '_blank' : '_self'}
                >
                  {mainMenuItem.menuItemLabel}{' '}
                  {mainMenuItem?.enableDropdown && (
                    <Icon
                      iconClass={clsx(
                        'icon-arrow',
                        selectedMainMenuItemIndex === menuItemIndex ? 'icon-arrow-up' : 'icon-arrow-down'
                      )}
                    />
                  )}
                </Button>
                {mainMenuItem?.enableDropdown &&
                  mainMenuItem?.sectionNavigationSubItems?.length &&
                  selectedMainMenuItemIndex === menuItemIndex && (
                    <div className="navigation-dropdown-container">
                      <NavigationDropdown
                        menuItemLabel={mainMenuItem.menuItemLabel}
                        ariaLabel={mainMenuItem.menuItemLabel}
                        sectionNavigationSubItems={mainMenuItem.sectionNavigationSubItems}
                        activeMenuItem={props?.activeMenuItem}
                        trackingProperties={props?.trackingProperties}
                        menuItemIndex={menuItemIndex}
                      />
                    </div>
                  )}
              </StyledMainMenuItem>
            ))}
          </StyledMainMenu>
        </div>
      </nav>
    </StyledHWSPrimaryDetachedNavigation>
  );
};

export default HWSSecondaryNavigationDesktop;
